const { createBrowserHistory } = require("history")

export default createBrowserHistory()
